var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-observer',{on:{"intersect":function($event){return _vm.$emit('loadMore')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }